import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionProfile,
  CvSectionProfileResponse,
  UpdateCvSectionProfileRequest,
} from '@/../gen';

export const namespace = 'cvSectionProfile';
const actionCreator = actionCreatorFactory(namespace);
export interface CvSectionProfileParams {
  cv_id: number;
}

export const GetCvSectionProfile = actionCreator<CvSectionProfileParams>(
  'GET_CV_SECTION_PROFILE'
);
export const SetCvSectionProfile = actionCreator<CvSectionProfileResponse>(
  'SET_CV_SECTION_PROFILE'
);
export const UpdateCvSectionProfile = actionCreator<{
  params: CvSectionProfileParams;
  body: UpdateCvSectionProfileRequest;
}>('UPDATE_CV_SECTION_PROFILE');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionProfile: CvSectionProfile;
}

const initialState = (): State => {
  return { cvSectionProfile: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionProfile, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionProfile(
        action.payload.cv_id
      );
      context.commit(SetCvSectionProfile(data.data));
    }),
    action(UpdateCvSectionProfile, async function(context, action) {
      const { params, body } = action.payload;
      const {
        title,
        full_name,
        birthday_year,
        birthday_month,
        birthday_day,
        sex,
        email,
        phone_number,
        location,
        headline,
        website_url,
        profile_image,
        remove_profile_image,
      } = body;
      const { data } = await this.proffApi.updateCvSectionProfile(
        params.cv_id,
        title,
        full_name,
        birthday_year,
        birthday_month,
        birthday_day,
        sex,
        email,
        phone_number,
        location,
        headline,
        website_url,
        profile_image,
        remove_profile_image
      );
      context.commit(SetCvSectionProfile(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionProfile, (state, action) => {
      state.cvSectionProfile = action.payload.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionProfile: state => state.cvSectionProfile,
  },
};
